// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9031) return "static/chunks/e89fb3a8-6809800a952a895d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1624":"ff600953597e08c6","2467":"87461227cbc3210e"}[chunkId] + ".js";
};